angular.module 'zc.projects'

.controller 'UserIndexCtrl', ($scope, $stateParams, ProjectUser, currentProject) ->
  $scope.users = []
  $scope.isDisplayAajsWarningMsg = currentProject.enable_aajs &&
    _.some([
      currentProject.site_id,
      currentProject.tracking_id,
      currentProject.scope_id
    ],
      (item) => !(item && item.length > 0)
    )

  ProjectUser.all $stateParams.projectId
  .then (users) ->
    $scope.users = users

  $scope.remove = (id) =>
    ProjectUser.delete $stateParams.projectId, id
    .then (res) ->
      $scope.users = _.reject($scope.users, (user) -> user.id == id)



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/users/index.controller.coffee